import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { GetFormattedDate } from "../../../components/utils/DateTimeUtils";
import {
  ClientMenu,
  SecondaryNavClient,
} from "../../../components/AdminComponents/MenuItems";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
// eslint-disable-next-line no-unused-vars
import {
  Button,
  Form,
  Input,
  Select,
  Spin,
  DatePicker,
  Tag,
  Switch,
  Row,
  Col,
} from "antd";
import "../formStyles.css";
// eslint-disable-next-line no-unused-vars
import ContactsTable from "../../../components/AdminComponents/ContactsTable";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import Axios from "../../../api/Axios";
import moment from "moment";
import { setClientData } from "../../../store/slices/OrgDetail";
import { useDispatch } from "react-redux";
import { message } from "antd";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import {
  BackwardOutlined,
  FormOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import { PatternFormat } from "react-number-format";
import { GetCookie } from "../../../config";
import {
  capitalizeWords,
  ClientTypeDropDown,
  ModuleColor,
} from "../../../components/icons/ApplicationColor";
import {
  getRoleTrue,
  getUpdateStatus1,
  // getViewStatus1,
} from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
const { RangePicker } = DatePicker;
const { Option } = Select;
const ClientInfo = () => {
  const history = useNavigate();
  const { id } = useParams();
  const TableData = useSelector((state) => state.tableData);
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus1(userInfo, 0, 0);
  // console.log(
  //   getViewStatus1(userInfo, 0, 3),
  //   SecondaryNavClient,
  //   "SecondaryNavClient"
  // );
  const [clientTypeOptions, setClientTypeOptions] = useState([]);
  const [showNtee, setShowNtee] = useState(false);
  const [purposeTypes, setPurposeTypes] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  // eslint-disable-next-line no-unused-vars
  const record = TableData.find((record) => record.key === id);
  const [nteeCode, setNteeCode] = useState([]);
  const [nteeCoreCode, setNteeCoreCode] = useState([]);
  const [accountExe, setAccountExe] = useState([]);
  const csrfToken = GetCookie("csrftoken");
  const [initailNteeCode, setInitialNteeCode] = useState("");
  const [showContract, setShowContract] = useState(true);
  //console.log(csrfToken);
  //console.log("first");
  //console.log("latest token", GetCookie("csrftoken"));
  // eslint-disable-next-line no-unused-vars
  const [errors, setErrors] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const formRef = useRef();

  const handleReset = () => {
    loadForm();
  };
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const LoadUser = async () => {
    try {
      const res = await Axios.get(`/organization/${id}/`);
      setData1(res.data);
      setLoading(false);
      //console.log(res.data);
      if (res.data?.org_type === "non-profit") {
        setShowNtee(true);
      }
      const { client_id, name, contract_start_date, contract_end_date } =
        res.data;
      dispatch(
        setClientData({
          client_id,
          name,
          contract_start_date,
          contract_end_date,
        })
      );
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    const accountExeDropDown = async () => {
      const res = await Axios.get("options/purpose/");
      //console.log(res.data);
      setPurposeTypes(res.data.purpose);
    };
    accountExeDropDown();
  }, []);
  useEffect(() => {
    LoadUser();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadForm = () => {
    if (!loading && formRef.current) {
      const formValues = {
        name: data1.name,
        client_id: data1.client_id,
        ein: data1.ein,
        address: data1.address,
        city: data1.city,
        email_login: data1.email_login,
        user_id_login: data1.user_id_login,
        zipcode: data1.zipcode,
        country: data1.country,
        state: data1.state,
        org_type: data1.org_type,
        ntee_code: data1.ntee_code?.id,
        tax_type: data1.tax_type,
        fiscal_end: data1?.fiscal_end,
        purpose: data1.purpose,
        naics_primary: data1.naics_primary,
        status: data1.status,
        client_type: data1.client_type,
        industry: data1.industry,
        relationship_type: data1.relationship_type,
        send_welcome_email: data1.send_welcome_email,
        partner_enabled: data1.partner_enabled,
      };

      if (data1.contract_start_date) {
        formValues.dateRange = [dayjs(data1.contract_start_date, "YYYY-MM-DD")];
      }
      if (data1.ntee_code) {
        NteeCoreCode(data1.ntee_code?.ntee_code);
        setInitialNteeCode(data1.ntee_code?.ntee_code);
        formValues.ntee_core_code = data1.ntee_core_code?.id;
      }

      if (data1.contract_end_date) {
        formValues.dateRange = [
          ...(formValues.dateRange || []),
          dayjs(data1.contract_end_date, "YYYY-MM-DD"),
        ];
      }
      if (data1.relationship_type === "Prospect") {
        setShowContract(false);
      }
      formRef.current.setFieldsValue(formValues);
      setSelectedCountry(data1.country);
      setSelectedState(data1.state);
    }
  };
  useEffect(() => {
    if (!loading && formRef.current) {
      const formValues = {
        name: data1.name,
        client_id: data1.client_id,
        ein: data1.ein,
        address: data1.address,
        city: data1.city,
        email_login: data1.email_login,
        user_id_login: data1.user_id_login,
        zipcode: data1.zipcode,
        country: data1.country,
        state: data1.state,
        org_type: data1.org_type,
        ntee_code: data1.ntee_code?.id,
        tax_type: data1.tax_type,
        fiscal_end: data1?.fiscal_end,
        purpose: data1.purpose,
        naics_primary: data1.naics_primary,
        status: data1.status,
        client_type: data1.client_type,
        industry: data1.industry,
        relationship_type: data1.relationship_type,
        send_welcome_email: data1.send_welcome_email,
        account_executive: data1.account_executive,
        partner_enabled: data1.partner_enabled,
      };

      if (data1.contract_start_date) {
        formValues.dateRange = [dayjs(data1.contract_start_date, "YYYY-MM-DD")];
      }
      if (data1.contract_end_date) {
        formValues.dateRange = [
          ...(formValues.dateRange || []),
          dayjs(data1.contract_end_date, "YYYY-MM-DD"),
        ];
      }
      if (data1.relationship_type === "Prospect") {
        setShowContract(false);
      }
      if (data1.ntee_code) {
        NteeCoreCode(data1.ntee_code?.ntee_code);
        setInitialNteeCode(data1.ntee_code?.ntee_code);
        formValues.ntee_core_code = data1.ntee_core_code?.id;
      }

      formRef.current.setFieldsValue(formValues);
      setSelectedCountry(data1.country);
      setSelectedState(data1.state);
    }
  }, [loading, data1]);

  const onFinish = async (values) => {
    //console.log("Received values of form: ", values);
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );

    // Remove the 'dateRange' field from the normalizedValues object
    delete normalizedValues.dateRange;

    // Retrieve the selected dates from the 'dateRange' field
    const selectedDates = values.dateRange;

    if (selectedDates && selectedDates.length > 0) {
      const contract_start_date = selectedDates[0].format("YYYY-MM-DD");
      normalizedValues.contract_start_date = contract_start_date;
      if (selectedDates.length === 2 && selectedDates[1] !== null) {
        const contract_end_date = selectedDates[1].format("YYYY-MM-DD");
        normalizedValues.contract_end_date = contract_end_date;
      }
    }
    const naics = normalizedValues.naics_primary?.split("-")[0]?.trim();
    normalizedValues.naics = naics;
    if (naics === "") {
      delete normalizedValues.naics;
    }

    const formattedDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    normalizedValues.updated_at = formattedDate;

    //console.log("Received values of form: ", normalizedValues);

    try {
      await Axios.put(`/organization/${parseInt(id)}/`, normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      UpdateSuccessfull();
    } catch (err) {
      // console.log(err);
      UpdateFailed(err?.response?.data?.detail);
    }
  };
  const UpdateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Details have been updated.",
      duration: 5,
    });
  };

  const UpdateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: props ? props : "Details have not been updated.",
      duration: 5,
    });
  };
  useEffect(() => {
    const clientTypeDropDown = async () => {
      const res = await Axios.get("options/org_type/");
      //console.log(res.data);
      setClientTypeOptions(res.data.org_type);
    };
    clientTypeDropDown();
  }, []);

  useEffect(() => {
    const NteeCode = async () => {
      const res = await Axios.get("/nteecode/");
      //console.log(res.data, "NteeCode");
      setNteeCode(res.data);
    };
    NteeCode();
  }, []);
  const NteeCoreCode = async (code) => {
    const res = await Axios.get(`/nteecorecode/?search=${code}`);
    //console.log(res.data, "NteeCoreCode");
    setNteeCoreCode(res.data);
  };
  useEffect(() => {
    const purposeTypesDropDown = async () => {
      const res = await Axios.get("options/purpose/");
      //console.log(res.data);
      setPurposeTypes(res.data.purpose);
    };
    purposeTypesDropDown();
  }, []);
  useEffect(() => {
    const accountExeDropDown = async () => {
      const res = await Axios.get("userlist/?role=account_executive");
      //console.log(res.data);
      setAccountExe(res.data);
    };
    accountExeDropDown();
  }, []);
  const handleClientTypeChange = (value) => {
    //console.log(`Selected client type: ${value}`);
    if (value === "non-profit") {
      setShowNtee(true);
    } else {
      setShowNtee(false);
    }
  };
  const handleRelationShipTypeChange = (value) => {
    if (value === "Prospect") {
      setShowContract(false);
    } else {
      setShowContract(true);
    }
  };
  const handleNteeCode = (value, option) => {
    const selectedNteeCode = option?.["data-ntee-code"];
    //console.log("Selected NTEE Code:", selectedNteeCode);
    if (selectedNteeCode === initailNteeCode) {
      formRef.current.setFieldsValue({
        ntee_core_code: data1.ntee_core_code?.id,
      });
    } else {
      formRef.current.setFieldsValue({
        ntee_core_code: null,
      });
    }
    NteeCoreCode(selectedNteeCode);
  };
  const [isUserExists, setIsUserExists] = useState(false);
  const [isUserIDExists, setIsUserIDExists] = useState(false);
  const handleFormChange = async (changedValues, allValues) => {
    if ("name" in changedValues && allValues.name.length > 3) {
      if ("name" in changedValues && allValues.name === data1.name) {
        setIsUserExists(false);
      } else {
        const response = await Axios.get(`/orgcheck/?search=${allValues.name}`);
        //console.log(response);
        setIsUserExists(response.data.exists);
      }
    }
    if ("client_id" in changedValues && allValues.client_id.length > 3) {
      if (
        "client_id" in changedValues &&
        allValues.client_id === data1.client_id
      ) {
        setIsUserIDExists(false);
      } else {
        const response = await Axios.get(
          `/orgcheck/?search=${allValues.client_id}`
        );
        //console.log(response);
        setIsUserIDExists(response.data.exists);
      }
    }
    // if ("naics_primary" in changedValues && allValues.naics_primary.length > 3) {
    //   const response = await Axios.get(
    //     `/naicslist/?search=${allValues.naics_primary}`
    //   );
    //   console.log(response);
    //   setNaicsRes(response.data);
    // }
  };
  const checkUserExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists().then(resolve, reject);
        }, 100);
      } else if (isUserExists) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };
  const checkUserIDExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserIDExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserIDExists().then(resolve, reject);
        }, 100);
      } else if (isUserIDExists) {
        reject("Client ID already exists");
      } else {
        resolve();
      }
    });
  };
  const [naicsRes, setNaicsRes] = useState([]);
  const [selectedNaics, setSelectedNaics] = useState("");

  const handleNaicsSearch = async (value) => {
    //console.log(value);
    if (value.length >= 2) {
      const response = await Axios.get(`/naicslist/?search=${value}`);
      //console.log(response);
      setNaicsRes(response.data);
    } else {
      setNaicsRes([]);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const formatDate = (text) => {
    const date = new Date(text);
    const month = date
      .toLocaleString("default", { month: "short" })
      .toUpperCase();
    const day = date.getDate();

    const year = date.getFullYear();
    const formattedDate = `${day} ${month} ${year}`;
    return formattedDate;
  };

  const handleNaicsSelect = (value) => {
    setSelectedNaics(value);
  };

  const handleNaicsBlur = () => {
    if (!selectedNaics) {
      setSelectedNaics("");
    }
  };
  const renderRows = (applications) => {
    const rows = [];
    for (let i = 0; i < applications.length; i += 2) {
      rows.push(
        <div className="antd-test-tag">
          <Row gutter={20} key={`row-${i}`} style={{ marginBottom: "1rem" }}>
            {applications.slice(i, i + 2).map((application) => (
              <Col
                xs={21}
                sm={21}
                md={12}
                lg={12}
                xl={12}
                key={application.name}
              >
                <Tag
                  color={ModuleColor(application.name)}
                  className="my-form-input-antd-test-tag"
                >
                  <span
                    className="tag-container"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      lineHeight: "3rem",
                      padding: "0.3rem",
                    }}
                  >
                    {application.name}
                  </span>

                  {application.end_date && (
                    <span>
                      Expires on - {GetFormattedDate(application.end_date)}
                    </span>
                  )}
                </Tag>
              </Col>
            ))}
          </Row>
        </div>
      );
    }
    return rows;
  };
  return (
    <Sidebar props={ClientMenu} style={{ overFlowX: "hidden !important" }}>
      {contextHolder}
      <Spin spinning={loading}>
        <SecondaryNav id={parseInt(id)} menuItems={SecondaryNavClient} />
        <div className="form-container-2">
          <Form
            name="complex-form"
            onFinish={onFinish}
            onValuesChange={handleFormChange}
            layout="vertical"
            ref={formRef}
            labelCol={{
              span: 25,
            }}
            wrapperCol={{
              span: 80,
            }}
            style={{
              Width: "100%",
            }}
            disabled={!updateAuth}
          >
            <div className="one">
              <div className="Child1">
                <div className="group1">
                  <div className="form-heading">
                    {" "}
                    {capitalizeWords("CLIENT INFO")}
                  </div>
                  <div className="antd-test" style={{ marginTop: "2rem" }}>
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                        <Form.Item
                          label={<p className="my-form-lables">Client Name</p>}
                          validateFirst={true}
                        >
                          <Form.Item
                            validateFirst={true}
                            name="name"
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "Username is required",
                              },

                              {
                                validator: checkUserExists,
                                validateTrigger: "onChange",
                              },
                            ]}
                          >
                            <Input
                              className="my-form-input-antd-test"
                              placeholder={"Enter client name"}
                              // disabled
                              autoComplete="off"
                              style={{
                                opacity: 1,
                                color: "black",
                              }}
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={<p className="my-form-lables">Client ID</p>}
                          validateFirst={true}
                        >
                          <Form.Item
                            validateFirst={true}
                            name="client_id"
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "Client ID is required",
                              },
                              {
                                max: 20,
                                message: "Must be less than 20 characters",
                              },
                              {
                                validator: checkUserIDExists,
                                validateTrigger: "onChange",
                              },
                            ]}
                          >
                            <Input
                              className="my-form-input-antd-test"
                              placeholder="Enter Client ID"
                              // style={{}}
                              // disabled
                              style={{
                                opacity: 1,
                                color: "black",
                              }}
                              autoComplete="off"
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={<p className="my-form-lables">Client Type</p>}
                        >
                          <Input.Group compact>
                            <Form.Item
                              name="org_type"
                              noStyle
                              rules={[
                                {
                                  required: true,
                                  message: "Client Type is required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Type"
                                className="my-form-input-antd-test"
                                onChange={handleClientTypeChange}
                              >
                                <Option value="">None</Option>
                                {clientTypeOptions?.map((option) => (
                                  <Option key={option} value={option}>
                                    {option === "govern"
                                      ? "government"
                                      : option}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5} lg={4} xl={4}>
                        <Form.Item
                          label={<p className="my-form-lables">EIN/Tax ID</p>}
                        >
                          <Form.Item
                            name="ein"
                            noStyle
                            rules={[
                              {
                                pattern: /^\d{2}-\d{7}$/,
                                message: "format req xx-xxxxxxx",
                              },
                            ]}
                          >
                            <PatternFormat
                              disabled={!updateAuth}
                              format="##-#######"
                              className="my-form-input-antd-test"
                              style={{
                                paddingTop: "0.4rem",
                                paddingBottom: "0.4rem",
                                paddingLeft: "0.4rem",
                                border: "0.15rem solid black",
                              }}
                              placeholder={" xx-xxxxxxx"}
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                  <div className="antd-test">
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                        <Form.Item
                          label={<p className="my-form-lables">Address</p>}
                        >
                          <Form.Item name="address" noStyle>
                            <Input
                              className="my-form-input-antd-test"
                              placeholder="Enter client's address"
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={<p className="my-form-lables">Country</p>}
                        >
                          <Input.Group compact>
                            <Form.Item name="country" noStyle>
                              <CountryDropdown
                                disabled={!updateAuth}
                                value={selectedCountry}
                                onChange={(val) => setSelectedCountry(val)}
                                placeholder="Select County"
                                className="my-form-input-antd-test"
                                style={{ height: "3.5rem" }}
                              />
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={<p className="my-form-lables">State</p>}
                        >
                          <Input.Group compact>
                            <Form.Item name="state" noStyle>
                              <RegionDropdown
                                disabled={!updateAuth}
                                country={selectedCountry}
                                value={selectedState}
                                onChange={(val) => setSelectedState(val)}
                                className="my-form-input-antd-test"
                                style={{ height: "3.5rem" }}
                              />
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                        <Form.Item
                          label={<p className="my-form-lables">City</p>}
                        >
                          <Form.Item name="city" noStyle>
                            <Input
                              className="my-form-input-antd-test"
                              placeholder="Enter City"
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>

                  <div className="antd-test">
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={5} lg={4} xl={4}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">ZIP/Postal Code</p>
                          }
                        >
                          <Form.Item
                            name="zipcode"
                            noStyle
                            rules={[
                              {
                                pattern:
                                  selectedCountry === "United Kingdom"
                                    ? /^[0-9a-zA-Z]*$/
                                    : /^[0-9]*$/,
                                message:
                                  selectedCountry === "United Kingdom"
                                    ? "Please enter valid characters only"
                                    : "Please enter numbers only",
                              },
                              {
                                min:
                                  selectedCountry === "United States" ||
                                  selectedCountry === "India" ||
                                  selectedCountry === "United Kingdom" ||
                                  selectedCountry === ""
                                    ? 5
                                    : undefined,
                                max:
                                  selectedCountry === ""
                                    ? 5
                                    : selectedCountry === "United States"
                                    ? 5
                                    : selectedCountry === "India"
                                    ? 6
                                    : selectedCountry === "United Kingdom"
                                    ? 7
                                    : undefined,
                                message: "Invalid postal code",
                              },
                            ]}
                          >
                            <Input
                              className="my-form-input-antd-test"
                              placeholder="zip code"
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                      {showNtee && (
                        <>
                          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item
                              name="ntee_code"
                              label={
                                <p className="my-form-lables">NTEE Category</p>
                              }
                            >
                              <Select
                                showSearch
                                placeholder="Select Ntee category"
                                className="my-form-input-antd-test"
                                onChange={(value, option) =>
                                  handleNteeCode(value, option)
                                }
                                filterOption={(inputValue, option) =>
                                  option.children
                                    .join("")
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase())
                                }
                              >
                                {nteeCode?.map((option) => (
                                  <Option
                                    key={option.id}
                                    value={option.id}
                                    data-ntee-code={option.ntee_code}
                                  >
                                    <strong>{option?.ntee_code}</strong> :{" "}
                                    {option?.description}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item
                              name="ntee_core_code"
                              label={
                                <p className="my-form-lables">NTEE Core Code</p>
                              }
                            >
                              <Select
                                showSearch
                                placeholder="Select Ntee Core Code"
                                className="my-form-input-antd-test"
                                filterOption={(inputValue, option) =>
                                  option.children
                                    .join("")
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase())
                                }
                              >
                                {nteeCoreCode?.map((option) => (
                                  <Option key={option.id} value={option.id}>
                                    <strong>{option?.ntee_core_code}</strong> :{" "}
                                    {option?.description}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                            <Form.Item
                              name="tax_type"
                              label={<p className="my-form-lables">Tax Type</p>}
                            >
                              <Select
                                placeholder="Select Tax Type"
                                className="my-form-input-antd-test"
                              >
                                <Option value="">None</Option>
                                <Option value="501-c-3">501(c)(3)</Option>
                                <Option value="501-c-4">501(c)(4)</Option>
                                <Option value="501-c-5">501(c)(5)</Option>
                                <Option value="501-c-6">501(c)(6)</Option>
                                <Option value="501-c-7">501(c)(7)</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>
                </div>

                <div className="group1" style={{ paddingTop: "0rem" }}>
                  <div className="form-heading">
                    {" "}
                    {capitalizeWords("ORGANIZATION PROFILE")}
                  </div>
                  <div className="antd-test" style={{ marginTop: "2rem" }}>
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={8} lg={9} xl={9}>
                        <Form.Item
                          label={<p className="my-form-lables">NAICS Code</p>}
                        >
                          <Form.Item name="naics_primary" noStyle>
                            <Select
                              showSearch
                              placeholder="Enter NAICS Code"
                              filterOption={false}
                              className="my-form-input-antd-test"
                              onSearch={handleNaicsSearch}
                              onSelect={handleNaicsSelect}
                              onBlur={handleNaicsBlur}
                              value={selectedNaics}
                            >
                              {naicsRes.map((naics) => (
                                <Option key={naics.code} value={naics.title}>
                                  {`${naics.title}`}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                        <Form.Item
                          label={<p className="my-form-lables">Purpose</p>}
                        >
                          <Input.Group compact>
                            <Form.Item name="purpose" noStyle>
                              <Select
                                placeholder="Purpose of the client"
                                className="my-form-input-antd-test"
                              >
                                <Option value="">None</Option>
                                {purposeTypes?.map((option) => (
                                  <Option key={option} value={option}>
                                    {option}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                        <Form.Item
                          label={<p className="my-form-lables">Fiscal end </p>}
                        >
                          <Input.Group compact>
                            <Form.Item name="fiscal_end" noStyle>
                              <Select
                                className="my-form-input-antd-test"
                                placeholder="Select Fiscal End"
                              >
                                <Option value={1}>January</Option>
                                <Option value={2}>February</Option>
                                <Option value={3}>March</Option>
                                <Option value={4}>April</Option>
                                <Option value={5}>May</Option>
                                <Option value={6}>June</Option>
                                <Option value={7}>July</Option>
                                <Option value={8}>August</Option>
                                <Option value={9}>September</Option>
                                <Option value={10}>October</Option>
                                <Option value={11}>November</Option>
                                <Option value={12}>December</Option>
                              </Select>
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                  <div className="antd-test">
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">Organization Type</p>
                          }
                        >
                          <Form.Item name="client_type" noStyle>
                            <Select
                              className="my-form-input-antd-test"
                              placeholder="Select Org Type"
                            >
                              <Option value={null}>None</Option>
                              {ClientTypeDropDown?.map((option) => (
                                <Option key={option} value={option}>
                                  {option}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                        <Form.Item
                          label={<p className="my-form-lables">Industry</p>}
                        >
                          <Form.Item
                            name="industry"
                            noStyle
                            rules={[
                              ({ getFieldValue }) => ({
                                required: !!getFieldValue("naics_primary"),
                                message:
                                  "Industry is required when NAICS Code is selected",
                              }),
                              {
                                pattern: /^[A-Za-z\s]*$/,
                                message: "Please enter valid words only",
                              },
                              {
                                min: 3,
                                message: "Minimum 3 characters required",
                              },
                            ]}
                          >
                            <Input
                              className="my-form-input-antd-test"
                              placeholder="Enter Industry"
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                      {/* <Col
                        xs={24}
                        sm={12}
                        md={4}
                        lg={4}
                        xl={4}
                        style={{ marginLeft: "1rem" }}
                      >
                        <Form.Item
                          label={<p className="my-form-lables">Email Login</p>}
                          name="email_login"
                          valuePropName="checked"
                        >
                          <Switch />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">User ID Login</p>
                          }
                          name="user_id_login"
                          valuePropName="checked"
                        >
                          <Switch />
                        </Form.Item>
                      </Col> */}
                      <Col
                        xs={24}
                        sm={12}
                        md={5}
                        lg={5}
                        xl={5}
                        style={{ marginLeft: "2rem" }}
                      >
                        <Form.Item
                          label={
                            <p className="my-form-lables">Send Welcome Email</p>
                          }
                          name="send_welcome_email"
                          valuePropName="checked"
                        >
                          <Switch
                            checkedChildren=" YES "
                            unCheckedChildren=" NO "
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">Partner Enabled</p>
                          }
                        >
                          <Form.Item
                            noStyle
                            name="partner_enabled"
                            valuePropName="checked"
                          >
                            <Switch
                              checkedChildren=" YES "
                              unCheckedChildren=" NO "
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                  {/* <div className="antd-test">
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                        <Form.Item
                          label={<p className="my-form-lables">Email Login</p>}
                          name="email_login"
                          valuePropName="checked"
                        >
                          <Switch />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">User ID Login</p>
                          }
                          name="user_id_login"
                          valuePropName="checked"
                        >
                          <Switch />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">Send Welcome Email</p>
                          }
                          name="send_welcome_email"
                          valuePropName="checked"
                        >
                          <Switch />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div> */}
                  <div className="group-1-box" style={{ paddingTop: "0rem" }}>
                    <div
                      style={{
                        display: "inline-block",
                        marginTop: "2px",
                      }}
                    >
                      <Form.Item label=" " colon={false}>
                        <Button
                          type="text"
                          htmlType="button"
                          style={{
                            background: "#D3D3D3",
                          }}
                          disabled={false}
                          onClick={() => {
                            history("/admin-manager/clients");
                          }}
                        >
                          <BackwardOutlined />
                          Back
                        </Button>
                      </Form.Item>
                    </div>

                    <div
                      style={{ display: "inline-block", marginLeft: "16px" }}
                    >
                      <Form.Item label=" " colon={false}>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={handleReset}
                        >
                          <RetweetOutlined />
                          Reset
                        </Button>
                      </Form.Item>
                    </div>
                    <div
                      style={{ display: "inline-block", marginLeft: "16px" }}
                    >
                      <Form.Item label=" " colon={false}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          // className="my-form-input-end"
                          style={{
                            background: "#f58029",
                          }}
                          className="save-update-btn"
                        >
                          Update
                          <FormOutlined />
                        </Button>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="Child2">
                <div className="group1">
                  <div
                    className="form-heading"
                    style={{ paddingLeft: "0rem", paddingTop: "2rem" }}
                  >
                    {capitalizeWords("RELATIONSHIP STATUS")}
                  </div>
                  <div className="antd-test" style={{ marginTop: "2rem" }}>
                    <Row gutter={20}>
                      <Col xs={21} sm={21} md={21} lg={21} xl={21}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">Account Executive</p>
                          }
                        >
                          <Form.Item
                            name="account_executive"
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "Account executive is required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              placeholder="Select Client's Account Executive"
                              className="my-form-input-antd-test"
                              filterOption={(inputValue, option) =>
                                option.children
                                  .join("")
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              }
                              disabled={getRoleTrue(
                                userInfo,
                                0,
                                0,
                                "account_executive"
                              )}
                            >
                              {accountExe?.map((option) => (
                                <Option key={option.id} value={option.id}>
                                  {option?.first_name} {option?.last_name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                  <div className="antd-test">
                    <Row gutter={20}>
                      <Col xs={21} sm={8} md={8} lg={8} xl={8}>
                        <Form.Item
                          label={<p className="my-form-lables">Status </p>}
                        >
                          <Form.Item
                            name="status"
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "Status is required",
                              },
                            ]}
                          >
                            <Select
                              className="my-form-input-antd-test"
                              placeholder="Select your status"
                              style={{ borderRadius: "0.5rem" }}
                            >
                              <Option value={true}>Active</Option>
                              <Option value={false}>Inactive</Option>
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>

                      <Col xs={21} sm={14} md={13} lg={13} xl={13}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">Relationship Type</p>
                          }
                        >
                          <Form.Item
                            name="relationship_type"
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "Relationship Type is required",
                              },
                            ]}
                          >
                            <Select
                              className="my-form-input-antd-test"
                              placeholder="Select Type"
                              style={{ borderRadius: "0.5rem" }}
                              onChange={handleRelationShipTypeChange}
                            >
                              <Option value={"Client"}>Client</Option>
                              <Option value={"Prospect"}>Prospect</Option>
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>

                  <div className="antd-test">
                    <Row gutter={20}>
                      <Col xs={21} sm={21} md={21} lg={21} xl={21}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">
                              {showContract
                                ? " Contract Start Date & end Date"
                                : " Trial Start Date & end Date"}
                            </p>
                          }
                        >
                          <Form.Item name="dateRange">
                            <RangePicker
                              placeholder={["Start Date", "End Date"]}
                              name="dateRange"
                              className="my-form-input-antd-test"
                              allowClear={false}
                            />
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="group1">
                  <div
                    className="form-heading"
                    style={{ paddingLeft: "0rem", paddingTop: "0rem" }}
                  >
                    {capitalizeWords("PRODUCTS")}
                  </div>
                  <div style={{ marginTop: "2rem" }}>
                    {renderRows(data1?.applications || [])}
                  </div>
                </div>
              </div>
            </div>
          </Form>
          {/* <ContactsTable data={record} /> */}
        </div>
      </Spin>
    </Sidebar>
  );
};

export default ClientInfo;
